var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1720,
    height: 652,
    viewBox: "0 0 1720 652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    width: 1720,
    height: 652,
    rx: 71,
    transform: "translate(100 4923)",
    fill: "#f0f0f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_14",
    "data-name": "Groupe de masques 14",
    transform: "translate(-100 -4923)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2996",
    "data-name": "Trac\\xE9 2996",
    d: "M-7034.5,11752.87c-142.187-48.926-237.112-157.342-220.914-331.026s156.109-65.292,31.92,157.32-235.539-682.807-616.494-597.665c-212.192,47.425,39.31,324.781,140.483,451.087,80.581,100.6,16.659,265.385,95.595,277.3,178.185,26.91,128.5-262.444-90.887-301.526s-328.552,108.2-254,501.923c30.565,161.431-85.978.026-151.538-152.908-60.429-140.965-145.172-232.987-226.579-220.974-113.353,21.658-51.519,187.847-94.258,221.041",
    transform: "translate(6610.368 -7504.759) rotate(-11)",
    fill: "none",
    stroke: "#e30613",
    strokeWidth: 10
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.5e91c18529fbdf61bf0918fd9b30325c.svg";
export { ForwardRef as ReactComponent };